import styled, { createGlobalStyle } from "styled-components";

import confirmIcon from "./img/keyboard-confirm@2x.png";
export const GlobalStyle = createGlobalStyle`
`;
export const InputCompleteWrapper = styled.div`
  height: 0.5rem;
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
  text-align: center;
  .words-num {
    display: inline-block;
    font-size: .18rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: .50rem;
  }
  .confirm-btn {
    width: 0.24rem;
    height: 0.18rem;
    top: 0.18rem;
    right: 0.16rem;
    position: absolute;
    background: transparent url(${confirmIcon}) center no-repeat;
    background-size: cover;
  }
`;
export const InputWrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999999;
  background: rgba(0, 0, 0, 0.9);
  textarea {
    outline: none;
    border: none;
    border-radius: calc(3rem / 100);
    resize: none;

    background: transparent;
    color: #eee;
    line-height: calc(26rem / 100);
    height: calc(100rem / 100);
    font-size: calc(20rem / 100);
    width: 86%;
    margin: calc(80rem / 100) auto;
    display: block;
    border: calc(1rem / 100) dotted grey;
    padding: calc(6rem / 100) calc(8rem / 100);
  }
  input {
    outline: none;
    border: none;
    border-radius: calc(3rem / 100);
    background: transparent;
    color: #eee;
    line-height: calc(50rem / 100);
    height: calc(50rem / 100);
    font-size: calc(20rem / 100);
    width: 86%;
    margin: calc(100rem / 100) auto;
    display: block;
    border: calc(1rem / 100) dotted grey;
    padding: 0 calc(8rem / 100);
  }
`;
